// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"654":"7c7d93e6","753":"e6015c68"}[chunkId] + ".chunk.css";
};